import { render, staticRenderFns } from "./autoConfirm.vue?vue&type=template&id=31f12c56&scoped=true&"
import script from "./autoConfirm.vue?vue&type=script&lang=js&"
export * from "./autoConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f12c56",
  null
  
)

export default component.exports